module.exports = __webpack_public_path__ + "img/bg.ffd23dd8.png";